// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.manage_questionPaper_results .card-group .card .subjects-list li:hover,
.manage_questionPaper_results .card-group .card .subjects-list li.active,
.manage_questionPaper_results .card-group .card .chapter-list li:hover,
.manage_questionPaper_results .card-group .card .chapter-list li.active {
  cursor: pointer;
  border-radius: 2px;
  background: #EFEFEF;
  padding: 0.2rem 0.5rem;
}
.manage_questionPaper_results .card-group .card .list-unstyled li {
  padding: 0.2rem 0.5rem;
  text-transform: uppercase;
}
@media (max-width: 991px) {
  .manage_questionPaper_results .card-group {
    display: flex;
    flex-flow: column wrap;
  }
  .manage_questionPaper_results .card-group .card {
    flex-direction: inherit;
    margin-bottom: 15px;
  }
  .manage_questionPaper_results .card-group .card + .card {
    margin-left: 0;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/neetjee_guru/components/questioners/manage_questin_papers/_managequestionpaper.scss"],"names":[],"mappings":"AAIY;;;;EAII,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAHhB;AAMY;EACI,sBAAA;EACA,yBAAA;AAJhB;AASI;EACI;IACI,aAAA;IACA,sBAAA;EAPV;EASU;IACI,uBAAA;IACA,mBAAA;EAPd;EAUU;IACI,cAAA;IACA,sCAAA;IACA,sBAAA;EARd;AACF","sourcesContent":[".manage_questionPaper_results {\n    .card-group {\n        .card {\n\n            .subjects-list li:hover,\n            .subjects-list li.active,\n            .chapter-list li:hover,\n            .chapter-list li.active {\n                cursor: pointer;\n                border-radius: 2px;\n                background: #EFEFEF;\n                padding: 0.2rem 0.5rem;\n            }\n\n            .list-unstyled li {\n                padding: 0.2rem 0.5rem;\n                text-transform: uppercase;\n            }\n        }\n    }\n\n    @media (max-width: 991px) {\n        .card-group {\n            display: flex;\n            flex-flow: column wrap;\n\n            .card {\n                flex-direction: inherit;\n                margin-bottom: 15px;\n            }\n\n            .card+.card {\n                margin-left: 0;\n                border: 1px solid rgba(0, 0, 0, 0.125);\n                border-radius: 0.25rem;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
